import Box from './Box';
import Root from './Root';
import Trigger from './Trigger';

const Tooltip = {
  Box,
  Root,
  Trigger,
};

export default Tooltip;
